import { Component, OnInit, AfterViewInit, HostListener, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpBackend } from '@angular/common/http';

import { RoutePartsService } from './shared/services/route-parts.service';

import { filter } from 'rxjs/operators';
import { UILibIconService } from './shared/services/ui-lib-icon.service';
import { JwtAuthService } from './shared/services/auth/jwt-auth.service';
import { NavigationService } from './shared/services/navigation.service';
import { PortalSettingsService } from './shared/services/portal-settings.service';
import { User } from './shared/models/user.model';
import { ProfileType } from './shared/enums/profile-type.enum';
import { IdleService } from './shared/services/idle/idle.service';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { LegacySelectPositionService } from './shared/services/legacy-select-position.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  appTitle = 'Medmate Portal';
  pageTitle = '';
  private idleServiceSubscription: Subscription;
  constructor(
    public title: Title,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private routePartsService: RoutePartsService,
    private iconService: UILibIconService,
    private http: HttpClient,
    private httpBackend: HttpBackend,
    private jwtAuth: JwtAuthService,
    private navService: NavigationService,
    private portalSettingsService: PortalSettingsService,
    private idleService: IdleService,
    private dialog: MatDialog,
    private legacySelectPosition: LegacySelectPositionService
  ) {
    iconService.init();
    this.legacySelectPosition.init();
  }

  ngOnInit() {
    this.portalSettingsService.portalSettings.subscribe(settings => {
      this.appTitle = settings.app_title
    })

    this.changePageTitle();
    if (this.jwtAuth.isLoggedIn()) {
      this.jwtAuth.checkTokenIsValid().subscribe((profile: User) => {
        if (this.jwtAuth.getIsDemoUserView()) {
          this.navService.publishNavigation(this.jwtAuth.getUser().role);
          this.navService.getOrderCountForMenu();
          return;
        }
        this.navService.publishNavigation(profile.role);
        this.navService.getOrderCountForMenu();
      })
    }

    if ([ProfileType.Doctor, ProfileType.Nurse, ProfileType.NursePractitioner].includes(this.jwtAuth.getUser().role)) {
      this.idleService.init();
      this.idleServiceSubscription = this.idleService.idleState.subscribe(() => {
        if (this.dialog.openDialogs.length > 0) {
          return;
        }
        window.location.reload();
      });
    }

  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    this.idleServiceSubscription.unsubscribe();
  }

  changePageTitle() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((routeChange) => {
      const routeParts = this.routePartsService.generateRouteParts(this.activeRoute.snapshot);
      if (!routeParts.length) {
        return this.title.setTitle(this.appTitle);
      }
      // Extract title from parts;
      this.pageTitle = routeParts
        .reverse()
        .map((part) => part.title)
        .reduce((partA, partI) => { return `${partA} > ${partI}` });
      this.pageTitle += ` | ${this.appTitle}`;
      this.title.setTitle(this.pageTitle);
    });
  }
}
